import styles from './styles.module.css'

const ContactCard = ({icon:Icon,title,description,contact=[]}) => {
    return (
        <div className={`${styles['contact-card']}`}>
            <div className={`${styles['icon']} d-flex align-items-center justify-content-center`}>
                {Icon}
            </div>
            <div className={`${styles['content']} mt-4`}>
                <h4>{title}</h4>
                <p>{description}</p>
                {contact.length > 0 && 
                    <ul className={`${styles['social-media']}`}>
                        {contact.map((item,index) =>
                            <li key={index}>
                                <a href={item.link} title={item.label} target={item.target}>{item.label}</a>
                            </li>    
                        )}                                             
                    </ul>
                }
            </div>
        </div>
    );
};

export default ContactCard;